import http from 'utils/http'

const getBusinessFromUser = (idCompany) => http.get('/user/v1/business/')


export default {
  getBusinessFromUser
}



// WEBPACK FOOTER //
// ./src/services/businessService.js